var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DistributorForm',{attrs:{"loading":_vm.loading,"title":_vm.title,"items":_vm.items,"type":_vm.type},on:{"update:loading":function($event){_vm.loading=$event},"reLoading":_vm.getDistributorDetail}})}
var staticRenderFns = []

export { render, staticRenderFns }